// Centralized feature flags for build-time toggles

function readEnv(name: string): string {
  try {
    const env: any = (import.meta as any)?.env ?? {};
    const v = env[name];
    return typeof v === 'string' ? v : String(v ?? '');
  } catch {
    return '';
  }
}

function asBool(v: string): boolean {
  const s = String(v || '').toLowerCase().trim();
  return s === '1' || s === 'true' || s === 'yes' || s === 'on';
}

// Primary switch to enable/disable online inscription + payments
// Prefer VITE_ENABLE_STRIPE if defined; fallback to VITE_FORMATIONS_ENROLLMENT_OPEN
const ENABLE_STRIPE = asBool(readEnv('VITE_ENABLE_STRIPE'));
const ENROLLMENT_OPEN = asBool(readEnv('VITE_FORMATIONS_ENROLLMENT_OPEN'));

export function isEnrollmentEnabled(): boolean {
  // If either flag explicitly set to true, enable.
  // If VITE_ENABLE_STRIPE is present and false, disable.
  // Default to true in dev unless explicitly disabled.
  if (readEnv('VITE_ENABLE_STRIPE') !== '') return ENABLE_STRIPE;
  if (readEnv('VITE_FORMATIONS_ENROLLMENT_OPEN') !== '') return ENROLLMENT_OPEN;
  // Default behavior: enabled in dev, disabled only when explicitly set in prod
  try {
    const env: any = (import.meta as any)?.env ?? {};
    const isDev = env?.DEV === true || env?.MODE === 'development';
    return isDev;
  } catch {
    return false;
  }
}

export function isStripeEnabled(): boolean {
  return isEnrollmentEnabled();
}

